import './App.css';
import './Component.css';
import Navbar from './components/navbar';
import Footer from './components/footer';
import React, { useState } from 'react';
import { Route, Routes, Navigate } from "react-router-dom";

import LkSis from './pages/lksis';
import LkSpy from './pages/lkspy';
import LkCrv from './pages/lkcrv';
import LkSwp from './pages/lkswp';
import LkMrg from './pages/lkmrg';
import Cldpr from './pages/cldrp';
import Adios from './pages/adios';
import Login from './pages/login';
import Home from './pages/home';

export default function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const handleLogin = () => {
        setIsAuthenticated(true);
    };
    const handleLogout = () => {
        setIsAuthenticated(false);
    };

    const handleRegister = (data) => {
        //alert('Registration functionality not implemented yet.');

        console.log('handleRegister', data);
    };

    const [theme, setTheme] = useState('light');
    const toggleTheme = () => {
        console.log('toggleTheme', theme);
        setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    return (
        <div className="App" data-theme={theme}>
            {isAuthenticated ? (
                <>
                    <Navbar onLogout={handleLogout} />
                    <div className='content-container'>
                        <div className="content" >
                            <Routes>
                                <Route path="/" element={<Home />} />

                                <Route path="/lksis" element={<LkSis />} />
                                <Route path="/lkcrv" element={<LkCrv />} />
                                <Route path="/lkswp" element={<LkSwp />} />
                                <Route path="/lkspy" element={<LkSpy />} />
                                <Route path="/lkmrg" element={<LkMrg />} />
                                <Route path="/cldrp" element={<Cldpr />} />

                                <Route path="/cldrp/option1" element={<Cldpr />} />
                                <Route path="/cldrp/option2" element={<Cldpr />} />
                                <Route path="/cldrp/option3" element={<Cldpr />} />

                                <Route path="/adios" element={<Adios />} />
                                <Route path="/home" element={<Home />} />
                                <Route path="*" element={<Navigate to="/" />} />
                            </Routes>
                        </div>
                    </div>
                    <Footer onToggleTheme={toggleTheme} />
                </>
            ) : (
                <Login onLogin={handleLogin} onRegister={handleRegister} />
            )}
        </div>
    );
}
